<template>
  <img
    class="wecoupon-mall-adcard"
    :src="imgurl"
    alt="ad image"
    v-stat.brow="{
      tag: 'theme_mall.ad_brow',
      ext: {
        fthemeid: data.id,
        fadid: data.dpId,
      },
    }"
    v-if="imgurl"
    @click="handleClick"
  />
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue-demi';
import { AdInfo, CardInfo } from '../../type';
import { windowHelper } from '@tencent/ppd-base-libs';

export default defineComponent({
  name: 'MallAdCard',
  components: {},
  props: {
    data: {
      type: Object as PropType<AdInfo & CardInfo>,
      required: true,
    },
  },
  setup(props, context) {
    const imgurl = computed(() => props.data.imgUrl || '');

    function handleClick() {
      const { jumpUrl } = props.data;
      windowHelper.redirect(jumpUrl, 300);
    }

    return {
      imgurl,
      handleClick,
    };
  },
});
</script>

<style lang="less" scoped>
@import (reference) '../../../../less/main.less';

.wecoupon-mall-adcard {
  width: 200 / @rem;
  height: 308 / @rem;
  overflow: hidden;
  border-radius: 8 / @rem;
  // box-shadow: 0px 0.02rem 0.02rem rgba(0, 0, 0, 0.1);
}
</style>
